<template>
  <div>
    <div class="grid grid-cols-1 gap-4 max-h-[60vh] overflow-y-auto">
      <div class="grid grid-cols-1 gap-6 mt-4 px-8">
        <div class="mb-4">
          <h3 class="text-sm font-semibold text-gray-600">Rejection Reason:</h3>
          <textarea
            v-model="labForm.reason"
            rows="4"
            placeholder="Type..."
            class="w-full border-gray-300 rounded p-2 bg-gray-50 mt-2"
          ></textarea>
        </div>
        <!-- <div class="mb-4">
          <h3 class="text-sm font-semibold text-gray-600">Comments:</h3>
          <textarea
            v-model="labForm.comment"
            rows="4"
            placeholder="Type..."
            class="w-full border-gray-300 rounded p-2 bg-gray-50 mt-2"
          ></textarea>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LabRejectionTab",
  created() {},
  data() {
    return {
      labForm: {
        reason: "",
        // comment: "",
      },
    };
  },
  props: {
    labTest: {
      type: Object,
      required: true,
    },
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped></style>
